import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import ServiceCard from '../components/ServiceCard';
import { companyInfo, detailedServices } from '../data/mock';

const Services = () => {
  const urgentService = detailedServices.find(s => s.urgent);
  const regularServices = detailedServices.filter(s => !s.urgent);

  return (
    <div className="min-h-screen pt-24">
      {/* Header */}
      <section className="py-12 bg-gradient-to-br from-[#0B2A4A]/5 via-white to-[#2F80ED]/5">
        <div className="container mx-auto px-4">
          <Badge className="bg-[#2F80ED] text-white mb-4">Nos services</Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B2A4A] mb-6">
            Tous nos services de plomberie
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed">
            Du dépannage d'urgence à la rénovation complète, AquaTherm Plomberie vous accompagne 
            dans tous vos projets. Devis gratuit, tarifs transparents, travail garanti.
          </p>
        </div>
      </section>

      {/* Urgent Service Highlight */}
      {urgentService && (
        <section className="py-8 bg-red-50 border-y border-red-200">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <AlertCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-[#0B2A4A] mb-2">
                    {urgentService.title}
                  </h3>
                  <p className="text-gray-700 mb-2">{urgentService.description}</p>
                  <p className="text-sm font-semibold text-red-600">{urgentService.price}</p>
                </div>
              </div>
              <a href={`tel:${companyInfo.phoneFormatted}`}>
                <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white gap-2 shadow-lg whitespace-nowrap">
                  <Phone className="w-5 h-5" />
                  Appeler maintenant
                </Button>
              </a>
            </div>
          </div>
        </section>
      )}

      {/* Services Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {regularServices.map((service) => (
              <ServiceCard key={service.id} service={service} detailed={true} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#0B2A4A] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Un projet ? Une urgence ?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Contactez-nous dès maintenant pour obtenir un devis gratuit ou pour un dépannage d'urgence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${companyInfo.phoneFormatted}`}>
              <Button size="lg" className="bg-[#2F80ED] hover:bg-white hover:text-[#0B2A4A] gap-2 transition-all duration-300">
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </Button>
            </a>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-[#0B2A4A] transition-all duration-300">
                Demander un devis
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
